import React from "react";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";

import { useStyles } from "./ListCard.styles";
import { TertiaryRow } from "./TertiaryRow";

interface ListCardProps {
  primary: React.ReactNode;
  secondary?: string;
  tertiary?: string[];
  footer?: React.ReactNode;
  highlights?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const ListCard = ({
  primary,
  secondary,
  tertiary,
  footer,
  highlights,
  className,
  onClick,
}: ListCardProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.root, className)} onClick={onClick}>
      <Box className={classes.primary}>
        <Box className={classes.primaryLeftSide}>{primary}</Box>
        <Box className={classes.primaryRightSide}>{highlights}</Box>
      </Box>
      <Box className={classes.subtitles}>
        {secondary && (
          <Box className={classes.secondary}>
            <Typography noWrap className={classes.subtitleFont}>
              {secondary}
            </Typography>
          </Box>
        )}
        {tertiary && (
          <Box className={classes.tertiary}>
            <TertiaryRow tertiary={tertiary} />
          </Box>
        )}
      </Box>
      {footer && <Box className={clsx(classes.footer, classes.subtitleFont)}>{footer}</Box>}
    </Box>
  );
};

export default ListCard;
